import React, { startTransition } from "react";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Categories, RightSidebar } from "../components";
import Socialicons from "../subComponent/Socialicons";
import { MdShoppingCart } from "react-icons/md";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import { useStateContext } from "../contexts/ContextProvider";
import Ratings from "../subComponent/Ratings";
import { Rating } from "@mui/material";
import NewArrivalsBanner from "../components/NewArrivalsBanner";
import FeaturedProduct from "../components/FeaturedProduct";

const Home = () => {
  const { setIsScrolled, CategoriesApiCall, itemRating } = useStateContext();
  useEffect(() => {
    CategoriesApiCall();
  }, []);

  window.onscroll = () => {
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  const frontPageDetail = [
    {
      text: "SUPACOOL Lightweight Casual Laptop Backpack With USB Charging Port For For Men And Women, School Bookbag For College",
      price: 274,
      rating: 4.7,
      header: "BACKPACK",
    },
    {
      text: "Marcy Dual Action Cross Training Recumbent Exercise Bike With Arm Exercisers, Gym Equipment For Work From Home Fitness, Black JX-7301",
      price: 274,
      rating: 4.9,
      header: "FITNESS",
    },
    {
      text: "OLEVS Mens Watches Chronograph Business Dress Quartz Stainless Steel Waterproof Luminous Date Wrist Watch",
      price: 274,
      rating: 4.8,
      header: "ACCESSORIES",
    },
    {
      text: "OneOdio Wired Over Ear Headphones Studio Monitor & Mixing DJ Stereo Headsets with 50mm Neodymium Drivers and 1/4 to 3.5mm Audio Jack for AMP Computer Recording Phone Piano Guitar Laptop - Black",
      price: 244,
      rating: 4.9,
      header: "HEADPHONES",
    },
  ];

  const slideLenght = frontPageDetail.length;
  const [angleRotate, setAngleRotate] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isTabActive, setIsTabActive] = useState(true);
  const [transition, setTransition] = useState(true);

  let slideInterval;
  let autoScroll = true;

  const HandleRotate = () => {
    setAngleRotate(angleRotate + 90);
    setCurrentSlide(currentSlide === slideLenght - 1 ? 0 : currentSlide + 1);
  };

  const HandleBackwards = () => {
    setAngleRotate(angleRotate - 90);
    setCurrentSlide(currentSlide === 0 ? slideLenght - 1 : currentSlide - 1);
  };

  function auto() {
    slideInterval = setInterval(HandleRotate, 7000);
  }
  useEffect(() => {
    if (autoScroll && !isMinimized && isTabActive) {
      auto();
    }
    return () => clearInterval(slideInterval);
  }, [currentSlide]);

  useEffect(() => {
    function handleResize() {
      setIsMinimized(window.innerWidth <= 768);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleVisibilityChange() {
      setIsTabActive(!document.hidden);
      //   if (document.hidden) {
      //    HandleRotate();}
      // } else if (autoScroll && isTabActive === false) {
      //   auto();
      // }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  useEffect(() => {
    setTransition(false);
    setTimeout(() => {
      setTransition(true);
    }, 700);
    HandleRotate();
  }, [isTabActive]);

  return (
    <HomeWrapper>
      <Component>
        <LeftHero>
          <Transformation>
            <Rotation
              style={{
                transform: `rotate(${angleRotate}deg)`,
                transition: `${transition ? "all 1s ease-in-out" : ""}`,
                opacity: `${transition ? 1 : 0}`,
              }}
            >
              {/* <Rotation > */}
              <img
                src="https://m.media-amazon.com/images/I/71PQHW6XUfL._AC_UX679_.jpg"
                alt="image1"
                style={{
                  width: 260,
                  top: -100,
                  left: 0,
                  transform: "rotate(-180deg)",
                }}
              />

              <img
                src="https://m.media-amazon.com/images/I/71Ir8uP8WAL._AC_SX679_.jpg"
                alt="image2"
                style={{ top: 0, right: -110, transform: "rotate(-90deg)" }}
              />
              <img
                src="https://m.media-amazon.com/images/I/81tJTNWROoL._AC_SX679_.jpg"
                alt="image3"
                style={{ bottom: 0, left: -100, transform: "rotate(-270deg)" }}
              />
              <img
                src="https://m.media-amazon.com/images/I/81135piFJeL._AC_SX679_.jpg"
                alt="image4"
                style={{ width: 260, bottom: -100, right: 0 }}
              />
            </Rotation>
          </Transformation>
        </LeftHero>
        <RightHero>
          <InfoPosition>
            <InfoWrapper>
              <motion.div
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: 1,
                }}
                transition={{
                  type: "spring",
                  duration: 1,
                  delay: 0.4,
                }}
              >
                <h4
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  {frontPageDetail[currentSlide].text}
                </h4>
              </motion.div>
              <div className="stars">
                <Rating
                  name="half-rating-read"
                  value={frontPageDetail[currentSlide].rating}
                  precision={0.1}
                  readOnly
                />
              </div>
              <p style={{ marginTop: "0px" }}>
                <sup style={{ fontSize: "14px" }}>$</sup>
                <b style={{ fontSize: "27px" }}>121</b>
                <sup style={{ fontSize: "14px" }}>99</sup>{" "}
              </p>
              <div className="buttons">
                <button
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  <MdShoppingCart style={{ fontSize: 15 }} /> Add to cart
                </button>{" "}
                <button style={{ background: "transparent" }}>
                  Explore More
                </button>
              </div>
            </InfoWrapper>
          </InfoPosition>
        </RightHero>
        {/* <BackgroundImage>
          <img src={backgroundStripe} alt="" />
        </BackgroundImage> */}

        <Blur></Blur>
        <Blur2></Blur2>
        <Blur3></Blur3>
        <Blur4></Blur4>

        <Socialicons />

        <BackgroundName>
          <h1>{frontPageDetail[currentSlide].header}</h1>
        </BackgroundName>
        <BsArrowRightShort
        className="hover-effect"
          style={{
            position: "absolute",
            top: "50%",
            right: "1px",
            fontSize: "44px",
            cursor: "pointer",
            zIndex: 444,
          }}
          onClick={HandleRotate}
        />
        <BsArrowLeftShort
          className="hover-effect"
          style={{
            position: "absolute",
            top: "50%",
            left: "1px",
            fontSize: "44px",
            cursor: "pointer",
            zIndex: 444,
          }}
          onClick={HandleBackwards}
        />
      </Component>
      <Line></Line>
      <Categories />
    
    </HomeWrapper>
  );
};

export default Home;

const HomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Component = styled.div`
  background-color: #ffffff;
  display: flex;
  height: 100vh;
  position: relative;
  overflow: hidden;
.hover-effect {
  &:hover{
     height: 40px;
  width: 40px;
  border-radius: 50%;
  color: #dd26a9;
 
  background: rgba(18, 16, 16, 0.7);
  
  border: 1px solid #f7d8ee;
  backdrop-filter: blur(90px);
  }

}
   @media (max-width: 460px) {
    height: 90.7vh;
  };

`;

const LeftHero = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const RightHero = styled.div`
  width: 100%;
  width: 1900px;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Transformation = styled.div`
  height: 1000px;
  width: 1000px;
  transform: translate(-50%, -50%);
  @media (max-width: 440px) {
    transform: translate(-40%, -60%);
  }
`;

const Rotation = styled.div`
  height: 1000px;
  width: 1000px;
  position: relative;

  img {
    width: 290px;
    position: absolute;
    @media (max-width: 440px) {
      width: 190px!important;
    }
  }
`;

const InfoPosition = styled.div`
  position: absolute;
  width: 600px;
  border-radius: 10px;
  right: 40px;
  background: rgba(255, 255, 255, 0.1);
  z-index: 10;
  border: 1px solid #f7d8ee;
  backdrop-filter: blur(20px);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: 440px) {
    width: 340px;
    border-radius: 4px;
    right: 10px;
    bottom: 70px;
  }
  @media (max-width: 390px) {
    width: 320px;
  }
`;

const InfoWrapper = styled.div`
  margin: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  p {
    margin-top: 10px;
  }
  button {
    padding: 10px 17px;
    margin-right: 19px;
    border-radius: 40px;
    background-color: #edceef;
    border: 1px solid #936a95;
  }
  .buttons {
    display: flex;
  }
  @media (max-width: 440px) {
    margin: 10px;
    h4 {
      font-size: 12px !important;
    }
    .stars {
      transform: scale(0.7);
      margin-left: -14px;
    }
    b {
      font-size: 17px !important;
    }
    sup {
      font-size: 10px !important;
    }
    button {
      font-size: 12px !important;
      padding: 7px 10px;
      border-radius: 20px;
      margin-right: 10px;
    }
  }
`;

const BackgroundImage = styled.div`
  img {
    // height: 700px;
    height: 300px;
    position: absolute;

    // top: -120px;
    top: -70px;
    right: 0;
  }
`;
const Blur = styled.div`
  position: absolute;
  width: 20rem;
  height: 14rem;
  border-radius: 50%;
  //background: #fdddfc;
  background: #f9b2f7;
  filter: blur(54px);
  top: 20px;
  right: 10%;
  z-index: 1;
  @media (max-width: 440px) {
    width: 10rem;
    height: 4rem;
  }
`;

const rotateBlur1 = keyframes`
  0% {
    top: 20px;
  
  }


  50% {
    top: 70px;
   
  }


  100% {
    top: 20px;
   
  }
`;

const Blur2 = styled.div`
  position: absolute;
  width: 20rem;
  height: 14rem;
  border-radius: 50%;
  //background: #f0ddfd;
  background: #ce95f4;

  filter: blur(54px);
  top: 150px;
  right: 17%;
  z-index: 3;
  animation: ${rotateBlur1} 2s infinite ease-out;
  @media (max-width: 440px) {
    width: 10rem;
    height: 4rem;
  }
`;

const Blur3 = styled.div`
  position: absolute;
  width: 24rem;
  height: 14rem;
  border-radius: 50%;
  background: #efe9ac;

  filter: blur(44px);
  top: 140px;
  right: 4%;
  z-index: 2;
  @media (max-width: 440px) {
    width: 10rem;
    height: 4rem;
  }
`;

const Blur4 = styled.div`
  position: absolute;
  width: 59rem;
  height: 10rem;
  border-radius: 50%;
  background: #fdd8de;
  filter: blur(94px);
  bottom: 0;
  right: 0%;
  z-index: 1;
  @media (max-width: 440px) {
    width: 10rem;
    height: 4rem;
  }
`;

const BackgroundName = styled.div`
  position: absolute;
  bottom: -71px;
  left: 30%;

  @media (max-width: 914px) {
    bottom: -61px;
  }

  @media (max-width: 800px) {
    bottom: -41px;
  }
  @media (max-width: 660px) {
    bottom: -31px;
  }
  h1 {
    font-size: 100px;
    font-weight: 1000;
    @media (max-width: 1011px) {
      font-size: 80px;
    }
    @media (max-width: 914px) {
      font-size: 70px;
    }

    @media (max-width: 800px) {
      font-size: 50px;
    }
    @media (max-width: 660px) {
      font-size: 40px;
    }
    @media (max-width: 480px) {
      font-size: 37px;
    }
  }
  opacity: 0.1;

  z-index: 4;
`;

const Line = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1px;
  background: #f1f0f0;
`;
